export default "__VITE_ASSET__79324e71__"